/**
 * "Work email" (Figma D02): personal mailbox providers are refused, so a registration always names a
 * company domain Digital Realty can route to its account team.
 */
const PERSONAL_EMAIL_DOMAINS = new Set([
	"gmail.com",
	"googlemail.com",
	"yahoo.com",
	"ymail.com",
	"rocketmail.com",
	"hotmail.com",
	"outlook.com",
	"live.com",
	"msn.com",
	"icloud.com",
	"me.com",
	"mac.com",
	"aol.com",
	"proton.me",
	"protonmail.com",
	"pm.me",
	"gmx.com",
	"gmx.net",
	"gmx.de",
	"mail.com",
	"yandex.com",
	"yandex.ru",
	"qq.com",
	"163.com",
	"126.com",
	"hey.com",
	"fastmail.com",
	"tutanota.com",
	"zoho.com"
]);

/** Country variants of the big providers (hotmail.co.uk, yahoo.fr, outlook.de, …). */
const PERSONAL_PROVIDER_PREFIXES = ["yahoo.", "hotmail.", "outlook.", "live.", "gmx."];

export const emailDomain = (email: string) => email.trim().toLowerCase().split("@")[1] ?? "";

/** True for a personal mailbox (gmail.com, outlook.com, …), which registration refuses. Pure. */
export const isPersonalEmail = (email: string) => {
	const domain = emailDomain(email);
	return PERSONAL_EMAIL_DOMAINS.has(domain) || PERSONAL_PROVIDER_PREFIXES.some(prefix => domain.startsWith(prefix));
};

const SECOND_LEVEL_SUFFIXES = new Set(["co", "com", "org", "net", "ac", "gov", "ne", "or"]);

/**
 * A readable company name from the email domain, for the organization a new prospect gets
 * ("maya@northwind-logistics.co.uk" → "Northwind Logistics"). Pure; a guess the user can rename.
 */
export const companyFromEmail = (email: string) => {
	const labels = emailDomain(email).split(".").filter(Boolean);
	if (labels.length === 0) return undefined;
	// Drop the public suffix: one label ("com"), or two for "co.uk"-style domains.
	const suffixLength = labels.length > 2 && SECOND_LEVEL_SUFFIXES.has(labels.at(-2) ?? "") ? 2 : 1;
	const name = labels.slice(0, Math.max(1, labels.length - suffixLength)).at(-1) ?? labels[0] ?? "";
	return name
		.split(/[-_]+/)
		.filter(Boolean)
		.map(word => word[0]?.toUpperCase() + word.slice(1))
		.join(" ");
};
